/* As 27 unidades federativas.
   O CRM é emitido por Conselho Regional — número e UF andam sempre juntos, e o
   mesmo número em estados diferentes é de médicos diferentes. Lista fechada
   para o cadastro não aceitar qualquer par de letras; a API valida a mesma
   lista em api/crm.py. */
const UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS',
  'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC',
  'SP', 'SE', 'TO'
]

export default UFS
